<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>G H Raisoni Memorial One Day Rapid Chess Tournament Surajpur </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>G H Raisoni Memorial One Day Rapid Chess Tournament Surajpur </span></h2>
        </div>
        <p><strong>Date: </strong>24/05/2026</p>
        <p><strong>Venue: </strong>Saraswati Shishu Mandir School Surajpur</p>
        <p><strong>Organized By: </strong>Kalpana Prakash Welfare Foundation</p>
        <p><strong>In Association With: </strong>G H Raisoni Sports and Cultural Foundation</p>
        <h5 class="primary-purple">Introduction:</h5>
        <p>The 1st G H Raisoni Memorial One Day Rapid Chess Tournament Surajpur
            2026, organized by Kalpana Prakash Welfare Foundation in association with G. H.
            Raisoni University, was a grand success.</p>
        <p>The event witnessed enthusiastic participation with 94 registered players
            representing 5 different District of Surguja.The total prize fund was ₹30000, with
            the winner receiving ₹7,000.</p>

        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>

                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/tournament-report-surajpur-raisoni-memorial.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
